import { render } from "./etDesignFormItem.vue?vue&type=template&id=552a6ab6"
import script from "./etDesignFormItem.vue?vue&type=script&lang=js"
export * from "./etDesignFormItem.vue?vue&type=script&lang=js"

import "./etDesignFormItem.vue?vue&type=style&index=0&id=552a6ab6&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__